// @flow
import React from 'react';
import {
  getRetailTableCellObject,
  getFormattedDate,
  getFormattedTime,
  getUserDetailTableCellObject
} from '../../../../services/helpers';
import { zoomTableActionsConfig } from '../../../commons/zoomTable/zoomTableConfig';
import { RenderRetailTableActionButtons } from '../../../commons/tableActionButton/tableActionButton';

export const typeFilterList = [
  {
    val: null,
    key: 'ALL'
  },
  {
    val: 'MANUAL',
    key: 'MANUAL'
  },
  {
    val: 'DIGITAL',
    key: 'DIGITAL'
  }
];

export const depositedSlipsDashboardConfig = {
  columns: [
    {
      Header: 'Slip ID',
      headerClassName: 'flex-10 zt-custom-th',
      sortable: false,
      accessor: 'depositSlipNumber',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.depositSlipNumber,
          null,
          row.original
        ),
      className: 'zt-custom-td flex-10'
    },
    {
      headerClassName: 'zt-custom-th flex-9',
      Header: 'Deposit Date',
      sortable: false,
      className: 'zt-custom-td flex-9',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          getFormattedDate(row.original.createdAt),
          getFormattedTime(row.original.createdAt),
          row.original
        )
    },
    {
      Header: 'Deposited By',
      headerClassName: 'flex-15 zt-custom-th',
      sortable: false,
      // accessor: "depositedBy",
      Cell: (row: Object) =>
        getUserDetailTableCellObject(
          row.original.depositedBy && row.original.depositedBy.name,
          row.original.depositedBy && row.original.depositedBy.mobileNo,
          row.original.depositedBy && row.original.depositedBy.email,
          row.original
        ),
      className: 'zt-custom-td flex-15'
    },
    {
      Header: 'Deposit OU',
      headerClassName: 'flex-10 zt-custom-th',
      sortable: false,
      accessor: 'locationCode',
      Cell: (row: Object) =>
        getRetailTableCellObject(row.original.locationCode, null, row.original),
      className: 'zt-custom-td flex-10'
    },
    {
      Header: 'Mode',
      headerClassName: 'flex-10 zt-custom-th',
      sortable: false,
      accessor: 'paymentType',
      Cell: (row: Object) =>
        getRetailTableCellObject(row.original.paymentType, null, row.original),
      className: 'zt-custom-td flex-10'
    },
    {
      Header: 'Type',
      headerClassName: 'flex-10 zt-custom-th',
      sortable: false,
      accessor: 'depositSlipType',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.depositSlipType,
          null,
          row.original
        ),
      className: 'zt-custom-td flex-10'
    },
    {
      Header: 'Status',
      headerClassName: 'flex-10 zt-custom-th',
      sortable: false,
      accessor: 'status',
      Cell: (row: Object) =>
        getRetailTableCellObject(row.original.status, null, row.original),
      className: 'zt-custom-td flex-10'
    },
    {
      Header: 'Deposited Amount',
      headerClassName: 'flex-10 zt-custom-th',
      sortable: false,
      accessor: 'depositedAmount',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.depositedAmount,
          null,
          row.original
        ),
      className: 'zt-custom-td flex-10'
    },
    {
      Header: 'Collection Amount',
      headerClassName: 'flex-10 zt-custom-th',
      sortable: false,
      accessor: 'collectionAmount',
      Cell: (row: Object) =>
        getRetailTableCellObject(
          row.original.collectionAmount,
          null,
          row.original
        ),
      className: 'zt-custom-td flex-10'
    },
    {
      Header: 'Actions',
      headerClassName: 'flex-10 zt-custom-th',
      sortable: false,
      // accessor: "depositedAmount",
      Cell: obj => (
        <RenderRetailTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={
            zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.buttons
          }
        />
      ),
      className: 'zt-custom-td flex-10'
    }
  ],
  className: 'zoomTableLegacyWrapper',
  noDataText: 'No deposited slip found',
  minRows: 0,
  pageSizeOptions: [7, 10, 15, 25, 50, 100],
  style: { maxHeight: 'calc(100vh - 18rem)' }
};

export const depositedSlipDashboardTableActionConfig = {
  buttons: [
    {
      label: 'Map To Bank Slips',
      labelOnly: true,
      actionButtonRetailWrapper: { minWidth: '11rem' },
      hide: rowData =>
        rowData.depositSlipType !== 'DIGITAL' || rowData.isPayNearDepositSlip,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions &&
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions.viewDetails
        ) {
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions.viewDetails(
            rowData,
            'mapToBankSlips'
          );
        }
      }
    },
    {
      label: 'View Details',
      labelOnly: true,
      actionButtonRetailWrapper: { minWidth: '11rem' },
      onClick: rowData => {
        if (
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions &&
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions.viewDetails
        ) {
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions.viewDetails(
            rowData,
            'viewDetails'
          );
        }
      }
    },
    {
      label: 'Cancel',
      labelOnly: true,
      actionButtonRetailWrapper: { minWidth: '11rem' },
      hide: rowData =>
        !zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions
          .cancelDepositSlipEnabled ||
        rowData.status === 'CANCELLED' ||
        rowData.isPayNearDepositSlip,
      onClick: rowData => {
        if (
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions &&
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions.cancel
        ) {
          zoomTableActionsConfig.DEPOSITED_SLIPS_DASHBOARD.actions.cancel(
            rowData
          );
        }
      }
    }
  ]
};
